import {Injectable} from '@angular/core';
import {HarbourDuesDeclaration, StoreHarbourDuesDeclaration} from "@portbase/bezoekschip-service-typescriptmodels";
import {Observable} from "rxjs";
import {sendCommand} from "../../../common/utils";

@Injectable({
  providedIn: 'root'
})
export class HarbourDuesStoreService {
  store(declaration: HarbourDuesDeclaration,
        formValue: any, declare: boolean):
    Observable<StoreHarbourDuesDeclaration> {

    const mergedBerthVisits = declaration.visit.berthVisits.map((element, index) => {
      const formBerthVisitValue = formValue.berthVisits[index];
      return {...element, ...formBerthVisitValue};
    });

    const command: StoreHarbourDuesDeclaration = {
      crn: declaration.crn,
      declare,
      discount: formValue.discount,
      exemption: formValue.exemption,
      specialTariff: formValue.specialTariff,
      incidentals: formValue.incidentals,
      statementNumber: declaration.statementNumber,
      visit: {
        ...declaration.visit,
        berthVisits: mergedBerthVisits
      }
    };

    return new Observable(subscriber => {
      sendCommand(
        "com.portbase.bezoekschip.common.api.harbourdues.commands.StoreHarbourDuesDeclaration",
        command,
        () => {
          subscriber.next(command);
          subscriber.complete();
        }
      );
    });
  }
}
